export const ADDRESS_KEYS = [
  "address_line_1",
  "address_line_2",
  "city",
  "province",
  "postal_code",
  "country",
  "phone",
];

/** Address fields that identify (and are shared between) physical addresses — everything except the per-member phone. */
export const ADDRESS_IDENTITY_KEYS = ADDRESS_KEYS.filter((key) => key !== "phone");

function normalizeAddress(address) {
  const normalized = {};
  ADDRESS_KEYS.forEach((key) => {
    normalized[key] = address?.[key] ?? "";
  });
  if (!normalized.province && address?.state) {
    normalized.province = address.state;
  }
  return normalized;
}

function addressHasContent(address) {
  return Boolean(address.address_line_1 || address.city || address.postal_code);
}

function addressKey(address) {
  return ADDRESS_IDENTITY_KEYS.map((key) =>
    String(address[key] || "").trim().toLowerCase(),
  ).join("|");
}

/** Normalized key for matching an arbitrary address object against the collected options. */
export function addressMatchKey(address) {
  return addressKey(normalizeAddress(address));
}

function titleCaseType(type) {
  if (!type) return "";
  return type.charAt(0).toUpperCase() + type.slice(1);
}

function formatAddressLabel(address, type) {
  const lines = [
    address.address_line_1,
    address.address_line_2,
    address.city,
    [address.province, address.postal_code].filter(Boolean).join(" "),
  ].filter(Boolean);
  const summary = lines.join(", ");
  const typeLabel = titleCaseType(type);
  return typeLabel ? `${summary} — ${typeLabel}` : summary;
}

/** Distinct addresses already entered for members in this household, for reuse/pre-fill. */
export function collectHouseholdAddresses(household, { excludeMemberId } = {}) {
  const members = household?.members || [];
  const seen = new Set();
  const options = [];
  members.forEach((member) => {
    if (excludeMemberId && String(member?.id) === String(excludeMemberId)) return;
    const addresses = member?.personal_info?.address || [];
    addresses.forEach((rawAddress) => {
      const address = normalizeAddress(rawAddress);
      if (!addressHasContent(address)) return;
      const key = addressKey(address);
      if (seen.has(key)) return;
      seen.add(key);
      options.push({
        key,
        label: formatAddressLabel(address, rawAddress?.type),
        address,
      });
    });
  });
  return options;
}
